export const stripHtmlTags = (html?: string) => {
  if (!html) {
    return ''
  }

  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent || div.innerText || ''
}
